/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createManualVerification } from '../fn/user-verification/create-manual-verification';
import { CreateManualVerification$Params } from '../fn/user-verification/create-manual-verification';
import { createVerificationMemo } from '../fn/user-verification/create-verification-memo';
import { CreateVerificationMemo$Params } from '../fn/user-verification/create-verification-memo';
import { deleteUserVerification } from '../fn/user-verification/delete-user-verification';
import { DeleteUserVerification$Params } from '../fn/user-verification/delete-user-verification';
import { deleteVerificationMemo } from '../fn/user-verification/delete-verification-memo';
import { DeleteVerificationMemo$Params } from '../fn/user-verification/delete-verification-memo';
import { UserVerificationDto } from '../models/user-verification-dto';
import { UserVerificationMemoDto } from '../models/user-verification-memo-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedUserVerificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createManualVerification()` */
  static readonly CreateManualVerificationPath = '/api/user-verifications';

  /**
   * Creates a manual user verification in manual review state. Quite hacky...
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createManualVerification()` instead.
   *
   * This method doesn't expect any request body.
   */
  createManualVerification$Response(params?: CreateManualVerification$Params, context?: HttpContext): Observable<StrictHttpResponse<UserVerificationDto>> {
    return createManualVerification(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a manual user verification in manual review state. Quite hacky...
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createManualVerification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createManualVerification(params?: CreateManualVerification$Params, context?: HttpContext): Observable<UserVerificationDto> {
    return this.createManualVerification$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserVerificationDto>): UserVerificationDto => r.body)
    );
  }

  /** Path part for operation `deleteUserVerification()` */
  static readonly DeleteUserVerificationPath = '/api/user-verifications/{id}';

  /**
   * Deletes an user verification including its uploaded documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUserVerification()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserVerification$Response(params: DeleteUserVerification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteUserVerification(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an user verification including its uploaded documents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUserVerification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserVerification(params: DeleteUserVerification$Params, context?: HttpContext): Observable<void> {
    return this.deleteUserVerification$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createVerificationMemo()` */
  static readonly CreateVerificationMemoPath = '/api/user-verifications/{id}/memos';

  /**
   * Creates a memo for an existing verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createVerificationMemo()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createVerificationMemo$Response(params: CreateVerificationMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<UserVerificationMemoDto>> {
    return createVerificationMemo(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a memo for an existing verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createVerificationMemo$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createVerificationMemo(params: CreateVerificationMemo$Params, context?: HttpContext): Observable<UserVerificationMemoDto> {
    return this.createVerificationMemo$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserVerificationMemoDto>): UserVerificationMemoDto => r.body)
    );
  }

  /** Path part for operation `deleteVerificationMemo()` */
  static readonly DeleteVerificationMemoPath = '/api/user-verifications/{id}/memos/{memoId}';

  /**
   * Deletes a memo from an existing verification. This method is quite fake and just marks a memo as deleted, but doesn't actually delete it ... so just assume its kind of a patch.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteVerificationMemo()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVerificationMemo$Response(params: DeleteVerificationMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteVerificationMemo(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a memo from an existing verification. This method is quite fake and just marks a memo as deleted, but doesn't actually delete it ... so just assume its kind of a patch.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteVerificationMemo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVerificationMemo(params: DeleteVerificationMemo$Params, context?: HttpContext): Observable<void> {
    return this.deleteVerificationMemo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
